/**
 * AI Setup API Service
 *
 * API methods for the AI Application Setup feature.
 * Provides validate and setup endpoints.
 */

import apiClient from './client';
import type { ApiSuccessResponse } from '../types/api.types';
import type {
  TemplateInfo,
  AISetupValidateDTO,
  AISetupValidateResponse,
  AISetupDTO,
  AISetupResponse,
} from '../types/ai-setup.types';

// ============================================================================
// AI SETUP SERVICE
// ============================================================================

export const aiSetupService = {
  /**
   * Fetch available templates from the template repository
   */
  getTemplates: async (tenantId: string): Promise<TemplateInfo[]> => {
    const response = await apiClient.get<ApiSuccessResponse<TemplateInfo[]>>(
      `/tenants/${tenantId}/ai/templates`
    );
    return response.data.data;
  },

  /**
   * Validate application code and repository name before creation
   */
  validate: async (tenantId: string, data: AISetupValidateDTO): Promise<AISetupValidateResponse> => {
    const response = await apiClient.post<ApiSuccessResponse<AISetupValidateResponse>>(
      `/tenants/${tenantId}/ai/setup-application/validate`,
      data
    );
    return response.data.data;
  },

  /**
   * Execute the full AI setup flow
   * Creates application, token, repository, configures repo, pushes template
   */
  setup: async (tenantId: string, data: AISetupDTO): Promise<AISetupResponse> => {
    const response = await apiClient.post<ApiSuccessResponse<AISetupResponse>>(
      `/tenants/${tenantId}/ai/setup-application`,
      data
    );
    return response.data.data;
  },
};

export default aiSetupService;
